module.exports = __webpack_public_path__ + "img/景田万科分校@2x.05a8d705.png";